const StartRestartButtonState = Object.freeze({
    NO_BUTTON: 'NO_BUTTON',
    RESTART: 'RESTART',
    START: 'START',
});

module.exports = StartRestartButtonState;
